import type { NotificationDto } from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";
import type { UpdateNotificationBody } from "../../../../packages/shared-types/src/notifications";

export function useUpdateNotification() {
	return useMutation({
		mutationKey: ["notifications"],
		mutationFn: async (data: UpdateNotificationBody) => {
			const res = await fetch(`${SERVICE_API}/api/notifications/${data.id}`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify({ content: data.content }),
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to update notification");
			}

			return (await res.json()) as NotificationDto;
		},
	});
}
